import timeLimit from 'time-limit-promise';
import { parseJson } from '../api';
import { Cart } from '../domain';
import { LOCALSTORAGE_KEY } from './keys';
import sendErrorToSentry from './sentry';

export function getCart() {
  return parseJson(fetch(`/cart.js`, {}));
}

function getLauncherClickData(cart: Cart) {
  if (!cart) {
    return {};
  }
  return {
    cart_item_count: cart.item_count,
    cart_total_price: cart.total_price / 100,
    cart_currency: cart.currency,
    url: window.location.pathname,
  };
}

export default class Tracker {
  cartToken: string | null;
  shop: unknown;

  constructor() {
    this.cartToken = sessionStorage.getItem(LOCALSTORAGE_KEY);

    if (!this.cartToken) {
      getCart().then(({ token }) => {
        this.cartToken = token;
        sessionStorage.setItem(LOCALSTORAGE_KEY, token);
      });
    }
    this.shop = window.Shopify.shop;
  }

  trackLauncherClickOpen(offers, cart) {
    if (offers.length === 0) {
      return;
    }
    return this.track({
      event_type: 'launcher_click_open',
      cart_token: this.cartToken,
      shop: this.shop,
      data: getLauncherClickData(cart),
      offers: offers.map((o) => o.id),
    });
  }

  trackLauncherClickClose(cart) {
    return this.track({
      event_type: 'launcher_click_close',
      cart_token: this.cartToken,
      shop: this.shop,
      data: getLauncherClickData(cart),
    });
  }

  track(data) {
    const hostname = process.env.REACT_APP_API_HOSTNAME;
    const fetchResult = parseJson(
      fetch(`${hostname}api/track-offers`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify(data),
      }),
    ).catch((error) => sendErrorToSentry(error));

    return timeLimit(fetchResult, 500);
  }
}
